/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withRouter } from "react-router-dom";
import qs from "querystring-es3";
class VirtualSportsHeader extends React.Component {
  state = {
    isMenuOpen: false
  }
  toggleMenu = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }
  componentDidMount() {
    const query = this.props.location.search.substring(1);
    const { operator, token } = qs.parse(query);
    this.setState({ operator, token });
  }
  render() {
    return (
      <div className={`row `}>       
        <div className="col-12 p-0" style={{ padding: "0px !important;" }} >
          <div className="gametopnav englishcasino">
            {/* <a onClick={() => { this.props.changeGamePartner("All") }} className={this.props.gamePartner === "All" ? "active" : null}><img alt="" src={BASE_IMAGE_PATH+"/casino/casinomenuicon/provider-all.png"} className="ball-images-tab new-scrollmenu"/>All</a> */}
            <a onClick={() => { this.props.changeGameType("ALL") }} className={this.props.gameType === "ALL" ? "active" : null}>All</a>
            {/* { ( this.props.gamePartner === "All" || this.props.gamePartner === "Kiron" || this.props.gamePartner === "Edge Gaming" ) && <a onClick={() => { this.props.changeGameType("SLOT") }} className={this.props.gameType === "SLOT" ? "active" : null}>Slot Games</a>} */}
            { ( this.props.gamePartner === "All" || this.props.gamePartner === "Kiron" || this.props.gamePartner === "Golden Race") && <a onClick={() => { this.props.changeGameType("VIRTUAL") }} className={this.props.gameType === "VIRTUAL" ? "active" : null}>Virtual Sports</a>}
            { ( this.props.gamePartner === "All" || this.props.gamePartner === "Spadegaming") && <a onClick={() => { this.props.changeGameType("INSTANTWIN") }} className={this.props.gameType === "INSTANTWIN" ? "active" : null}>Shooting</a>}
            { ( this.props.gamePartner === "All" || this.props.gamePartner === "Spribe" ) && <a onClick={() => { this.props.changeGameType("OTHER") }} className={this.props.gameType === "OTHER" ? "active" : null}>Aviator</a>}
            {/* <a onClick={() => { this.props.changeGamePartner("Kiron") }} className={this.props.gamePartner === "Kiron" ? "active" : null}>Virtual Sports</a>
            <a onClick={() => { this.props.changeGamePartner("Spadegaming") }} className={this.props.gamePartner === "Spadegaming" ? "active" : null}>Shooting</a>
            <a onClick={() => { this.props.changeGamePartner("Spribe") }} className={this.props.gamePartner === "Spribe" ? "active" : null}>Aviator</a> */}
           </div>
        </div>
        
      </div>
    )
  }
}
export default withRouter(VirtualSportsHeader);